import { validateEmail } from './validateEmail';
import { REGEXP_SPECIAL_SYMBOLS } from '../config/constants';

const selectors = {
  controlDataAttr: 'data-control',
  fieldDataAttr: 'data-field',
  errorMsgDataAttr: 'data-error',
};

const ERROR_TYPES = {
  required: 'data-required-error',
  specialSymbols: 'data-spec-symbol-error',
  emailFormat: 'data-email-error',
};

export function checkFormValid(formId) {
  return new Promise((resolve, reject) => {
    const form = document.querySelector(`#${formId}`);
    const controls = form
      ? form.querySelectorAll(`[${selectors.controlDataAttr}]`)
      : [];

    if (checkFieldData()) {
      setBotTrapValue(form);
      const data = getEnteredValues(form);

      return resolve(data);
    }

    return reject(new Error(`Invalid control values for fromID: ${formId}`));

    function checkFieldData() {
      let isFormDataValid = true;

      controls.forEach((control) => {
        const dataField = control.querySelector(`[${selectors.fieldDataAttr}]`);

        if (dataField) {
          if (control.hasAttribute(ERROR_TYPES.required)) {
            if (!dataField.value.trim()) {
              isFormDataValid = false;
              setErrorMsg(control, ERROR_TYPES.required);
              return;
            }
          }

          if (control.hasAttribute(ERROR_TYPES.specialSymbols)) {
            if (REGEXP_SPECIAL_SYMBOLS.test(String(dataField.value))) {
              isFormDataValid = false;
              setErrorMsg(control, ERROR_TYPES.specialSymbols);
              return;
            }
          }

          if (control.hasAttribute(ERROR_TYPES.emailFormat)) {
            if (!validateEmail(dataField.value)) {
              isFormDataValid = false;
              setErrorMsg(control, ERROR_TYPES.emailFormat);
              return;
            }
          }

          removeErrorMsg(control);
        }
      });

      return isFormDataValid;
    }
  });
}

function setErrorMsg(control, errorType) {
  const errorText = control.getAttribute(errorType);
  let errorContainer = control.querySelector(`[${selectors.errorMsgDataAttr}]`);

  if (!errorContainer) {
    errorContainer = document.createElement('div');
    errorContainer.setAttribute(selectors.errorMsgDataAttr, 'true');
    control.appendChild(errorContainer);
  }

  if (errorText) {
    errorContainer.innerHTML = errorText;
  }
}

function getEnteredValues(formEl) {
  const formFields = formEl.querySelectorAll(`[${selectors.fieldDataAttr}]`);
  const enteredValues = {};

  if (formFields) {
    formFields.forEach((field) => {
      enteredValues[field.name] = field.value;
    });
  }

  return enteredValues;
}

function removeErrorMsg(control) {
  const errorContainer = control.querySelector(
    `[${selectors.errorMsgDataAttr}]`
  );

  if (errorContainer) {
    errorContainer.innerHTML = '';
  }
}

function setBotTrapValue(formEl) {
  const inputTrap = formEl.querySelector('[name="trap"]');

  if (inputTrap?.value === '' || inputTrap?.value === 'null') {
    inputTrap.value = 'not_a_bot';
  }
}
